import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../../../core/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserRoutingModule } from './user-routing.module';
import { UserComponent } from './user.component';
import { AddUserComponent } from './add-user/add-user.component';
import { UpdateUserComponent } from './update-user/update-user.component';
import { AuthoUserComponent } from './autho-user/autho-user.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule, MatButtonModule, MatSelectModule, MatCardModule, MatAutocompleteModule,
         MatIconModule, MatProgressBarModule } from '@angular/material';
import { NgMatAutocompleteModule } from 'src/app/shared/components/autocomplete/autocomplete.module';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { AddUserByFileComponent } from './add-user-by-file/add-user-by-file.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import {NgxMaskModule} from 'ngx-mask';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import { HotTableModule } from "@handsontable/angular";

@NgModule({
  declarations: [
    UserComponent,
    AddUserComponent,
    UpdateUserComponent,
    AuthoUserComponent,
    AddUserByFileComponent
  ],
  imports: [
    CommonModule,
    UserRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatAutocompleteModule,
    MatIconModule,
    MatProgressBarModule,
    NgMatAutocompleteModule,
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    NgMatAutocompleteModule,
    MatInputModule,
    NgxMaskModule.forChild(),
    NgxExtendedPdfViewerModule,
    NgZorroAntdModule,
    SlickCarouselModule,
    HotTableModule,
  ],
  entryComponents: [
    AddUserComponent,
    UpdateUserComponent,
    AuthoUserComponent,
    AddUserByFileComponent
  ],
  exports: [
    AddUserByFileComponent
  ]
})
export class UserModule { }
